/**
 * Theme-driven accent helpers for SavoirCare board UI.
 * Expected/Incoming reuse palette.audience; redirect uses text.secondary;
 * lounge + location pills use palette.board.
 */

/** @param {import('@mui/material/styles').Theme} theme */
export const getExpectedAccent = (theme) => theme.palette.audience?.patient?.main;

/** @param {import('@mui/material/styles').Theme} theme */
export const getIncomingAccent = (theme) => theme.palette.audience?.clinician?.main;

/** @param {import('@mui/material/styles').Theme} theme */
export const getRedirectAccent = (theme) => theme.palette.text.secondary;

/**
 * @param {import('@mui/material/styles').Theme} theme
 * @param {{ isExpected?: boolean, isIncoming?: boolean, isRedirect?: boolean }} flags
 */
export const getStageAccentColor = (theme, { isExpected, isIncoming, isRedirect }) => {
  if (isExpected) return getExpectedAccent(theme);
  if (isIncoming) return getIncomingAccent(theme);
  if (isRedirect) return getRedirectAccent(theme);
  return null;
};

/**
 * Map physical_location substring to theme board location pill colors.
 * @param {import('@mui/material/styles').Theme} theme
 * @param {string} value
 */
export const getLocationPillColors = (theme, value) => {
  const location = theme.palette.board?.location;
  const v = (value || '').toLowerCase();
  if (v.includes('lounge')) return location?.lounge;
  if (v.includes('trauma')) return location?.trauma;
  if (v.includes('procedure')) return location?.procedure;
  return location?.default;
};

/** @param {import('@mui/material/styles').Theme} theme */
export const getLoungeAccent = (theme) => theme.palette.board?.lounge?.border;

/** @param {import('@mui/material/styles').Theme} theme */
export const getLoungeMetaChip = (theme) => theme.palette.board?.lounge;
